<template>
    <div ref="aspect" class="tx-responsive">
        <div ref="sizer" class="tx-responsive__sizer" :class="[{loaded}]" v-aspect-ratio="aspectRatio"></div>
        <div ref="content" class="tx-responsive__content" :style="contentStyles">
            <slot v-if="loaded"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TxProductAspectRatio',
        props: {
            layout: {},
            size: {},
            aspectRatios: {},
        },
        data() {
            return {
                loaded: false,
                maxHeight: false
            }
        },
        watch: {
            aspectRatio: {
                handler: function (newValue, oldValue) {
                    this.fixMaxVerticalSize()
                },
                immediate: true
            }
        },
        created() {
            window.addEventListener('resize', this.onResize, {passive: true})
        },
        mounted() {
            this.onResize();
            this.$nextTick(() => {
                this.loaded = true
            })
            this._interval = setInterval(() => {
                this.fixMaxVerticalSize()
            }, 2500)
        },
        beforeDestroy() {
            clearInterval(this._interval);
            window.removeEventListener('resize', this.onResize)
        },
        methods: {
            onResize(event) {
                this.$emit('resized', {
                    height: this.$refs.aspect.clientHeight,
                    width: this.$refs.aspect.clientWidth,
                })
            },
            fixMaxVerticalSize() {
                if (this.$refs.sizer){
                    let sizer = window.getComputedStyle(this.$refs.sizer, null)
                    let height = sizer.getPropertyValue('padding-bottom')
                    this.maxHeight = height
                }
            },
        },
        computed: {
            contentStyles() {
                if (!this.maxHeight) {
                    return {}
                }
                return {
                    maxHeight: this.maxHeight
                }
            },
            aspectRatio() {
                let aspect = this.aspectRatios?.[this.layout]?.[this.size];

                if (aspect) {
                    let [aspectX, aspectY] = aspect;
                    return aspectX + ':' + aspectY;
                } else {
                    console.error('No aspect ratio detected');
                    return '1:1';
                }

            },
        }
    }
</script>

<style lang="scss" scoped>
    .tx-responsive {
        position: relative;
        overflow: hidden;
        flex: 1 0 auto;
        max-width: 100%;
        display: flex;

        &__sizer {
            &.loaded {
                transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1)
            }

            flex: 1 0 0px;
        }

        &__content {
            flex: 1 0 0px;
            max-width: 100%;
            margin-left: -100%;
        }
    }
</style>